import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-twenty-four-erp',
  templateUrl: './twenty-four-erp.component.html',
  styleUrls: ['./twenty-four-erp.component.css']
})
export class TwentyFourErpComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
